import React, { memo, useEffect, useMemo, useState } from 'react';
import { RoundStatus } from '@pascal/pascal-core';
import TimerAnimation from '../timerAnimation';
import { gameStore } from '../../../../../store';
import { soundService, soundTypes } from '../../../../../services';
import {
  MINIMUM_COUNTDOWN_RENDER_COUNT,
  RANG_MAX_VALUE,
  RANGE_MIN_VALUE,
  soundsNames,
} from '../../../../../enums';
import { soundsStore } from '../../../../../store/soundStore';

let delay;

const Striker = ({
  t,
  time,
  status,
  duration,
  isHummerHit,
  finishedOdd,
  showWinPopUp,
  soundsStates,
  isAnimationOn,
  oddRenderCount,
  setOddRenderCount,
  updateSoundsStates,
  gameAnimationDuration,
}) => {
  const { OnFinish, Started, OnHold } = RoundStatus;
  const [isCrack, setIsCrack] = useState(false);
  const [isRisingStar, setIsRisingStar] = useState(false);
  const [finishedOddCounter, setFinishedValueCounter] = useState(0);

  useEffect(() => {
    let intervalID = null;
    let innerCounter = 0;

    if (isHummerHit && !soundsStates.hummerSoundPlay) {
      soundsStore.playSoundByType(soundTypes.hummer);
      soundsStore.setSoundSeekTimeRange({ end: Date.now() });
      updateSoundsStates(soundsNames.hummerSoundPlay, true);
    }

    if (finishedOdd === RANGE_MIN_VALUE && status === OnFinish) {
      setTimeout(() => {
        setIsCrack(true);
        !isCrack && !soundsStates.crackSoundPlay && soundsStore.playSoundByType(soundTypes.crack);
        updateSoundsStates(soundsNames.crackSoundPlay, true);
      }, gameAnimationDuration);
    } else {
      setIsCrack(false);
    }
    if (finishedOdd) {
      delay = 1000 / finishedOdd;
      setTimeout(() => {
        if (!soundsStates.risingStarSoundPlay) {
          const withoutSeek = finishedOdd > 6;
          soundsStore.playSoundByType(soundTypes.risingStar, withoutSeek ? 0.5 : 1);
          updateSoundsStates(soundsNames.risingStarSoundPlay, true);
        }
        setOddRenderCount(++oddRenderCount);
        intervalID = setInterval(() => {
          innerCounter++;
          if (finishedOdd !== RANGE_MIN_VALUE) {
            setIsRisingStar(true);
          }
          setFinishedValueCounter(() => innerCounter);
          if (innerCounter >= Number(finishedOdd)) {
            if (soundsStates.risingStarSoundPlay) {
              soundService.stop(soundTypes.risingStar);
              updateSoundsStates(soundsNames.risingStarSoundPlay, false);
            }
            if (innerCounter === RANG_MAX_VALUE) {
              !soundsStates.bellSoundPlay && soundsStore.playSoundByType(soundTypes.bell);
              updateSoundsStates(soundsNames.bellSoundPlay, true);
            }
            setFinishedValueCounter(() => finishedOdd);
            showWinPopUp();
            clearInterval(intervalID);
          }
        }, delay);
      }, gameAnimationDuration);
    } else {
      setOddRenderCount(0);
      setFinishedValueCounter(0);
      setIsRisingStar(false);
    }

    return () => {
      intervalID && clearInterval(intervalID);
      setIsRisingStar(false);
    };
  }, [status, finishedOdd, isHummerHit]);

  const circleContent = useMemo(() => {
    return {
      [Started]: time,
      [OnFinish]:
        finishedOdd !== RANGE_MIN_VALUE && finishedOddCounter === RANGE_MIN_VALUE
          ? t('GO')
          : oddRenderCount <= MINIMUM_COUNTDOWN_RENDER_COUNT
          ? finishedOddCounter
          : finishedOdd,
      [OnHold]: t('GO'),
    };
  }, [status, time, finishedOddCounter, oddRenderCount]);

  return (
    <div className='str-g-block'>
      <div
        className={`hat-sprite-block ${
          finishedOddCounter === RANG_MAX_VALUE && isAnimationOn ? 'active' : ''
        }`}
      />
      {/* added/remove class active */}
      <div className={`str-game-inner-block ${isHummerHit ? 'active' : ''}`}>
        {/* added/remove class active */}
        <div className={`str-circle-go ${status === Started ? 'timer-start' : ''}`}>
          <p className='str-circle-go-txt'>{circleContent[status]}</p>
          <TimerAnimation
            time={time}
            isAnimationOn={isAnimationOn}
            isShowTimer={status === Started}
            duration={duration}
            timerDuration={gameStore.timerDuration}
          />
        </div>
        <div className='str-game-inner-clm'>
          {new Array(11).fill(100).map((item, idx) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <p className='str-game-inner-clm-number' key={item - 10 * idx}>
                {item - 10 * idx}
              </p>
            );
          })}
        </div>
        <div className='str-game-inner-clm right'>
          {new Array(10).fill(95).map((item, idx) => {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <p className='str-game-inner-clm-number' key={item - idx * 10}>
                {item - idx * 10}
              </p>
            );
          })}
        </div>
        <div className='str-game-line-wrp'>
          <span
            className='str-game-line-red'
            style={{
              height: finishedOdd && isRisingStar ? `${finishedOdd}%` : 0,
              transitionDuration: `1s`,
              // transitionDelay: `${gameAnimationDuration}ms`,
            }}
          />
        </div>
        <div
          className={`crack-sprite-block ${isCrack && isAnimationOn ? 'active' : ''}`}
          style={{
            animationDuration: `1s`,
            // transitionDelay: `${gameAnimationDuration}ms`,
          }}
        />
        <div className='striker-block-red-btn-wrp' />
        <div className='str-g-img-wrp'>
          <span className='str-g-shape shape1' />
          <span className='str-g-shape shape2' />
          <div className='hammer-block-wrp'>
            <div
              className='hammer-hit-block'
              onAnimationEnd={() => gameStore.setIsHummerHit(false)}
            />
            <div className={`hammer-move-block ${isAnimationOn ? 'hammer-move' : ''}`} />
          </div>
          <div
            className={`striker-light-bg-wrp ${
              (finishedOddCounter === finishedOdd && finishedOdd !== RANGE_MIN_VALUE) ||
              (finishedOdd === RANGE_MIN_VALUE && isCrack)
                ? ''
                : 'lightning'
            }`}
          >
            <div className='striker-light-bg left' />
            <div className='striker-light-bg right' />
          </div>
        </div>{' '}
        {/* added/remove class active */}
      </div>
    </div>
  );
};

export default memo(Striker);
